import * as React from 'react';
import { useSelector } from 'react-redux';
import { araRegelungenSelector } from 'store/lookups/selector';
import { requestAraRegelungen } from 'store/lookups/actions';
import { mergeStyleSets } from '@fluentui/react/lib/Styling';
import { DefaultButton, Dialog, DialogFooter, DialogType, Fabric, PrimaryButton } from '@fluentui/react';
import { viewStyles } from 'styles/viewStyles';
import { formStyles } from 'styles/formStyles';
import { FormTextField } from 'formComponents/FormTextField';
import { SavingState } from 'api/savingState';
import { addAraRegelung, defaultAraRegelung, AraRegelung, updateAraRegelung } from 'api/araRegelung';

const styles = mergeStyleSets({
    container: {
        position: 'relative',
        height: 'calc(100vh - 120px)',
        display: 'grid',
        gridTemplateRows: 'max-content 1fr',
        gridRowGap: 10,
    },
    searchBar: {
        display: 'grid',
        gridTemplateColumns: '1fr max-content',
        gridColumnGap: 10,
        marginTop: 10,
    },
});

export const AraRegelungen: React.FC = () => {
    const araRegelungen = useSelector(araRegelungenSelector);

    const [editData, setEditData] = React.useState<AraRegelung | null>(null);

    const save = async () => {
        if (!editData) {
            return;
        }
        if (editData?.art === -1) {
            await addAraRegelung(editData);
        } else {
            await updateAraRegelung(editData);
        }
        await requestAraRegelungen();
        setEditData(null);
    };

    return (
        <Fabric className={styles.container}>
            <div className={styles.searchBar}>
                <div />

                <PrimaryButton
                    onClick={() => setEditData({ ...defaultAraRegelung, art: -1 })}
                    text="Neue ARA Regelung"
                />
            </div>
            <div className={viewStyles.listContainerScroll}>
                <table className={formStyles.lookupTable}>
                    <thead className={formStyles.lookupTableHead}>
                        <tr>
                            <td className={formStyles.lookupTableCell}>Text</td>
                            <td className={formStyles.lookupTableCell} />
                        </tr>
                    </thead>
                    <tbody className={formStyles.lookupTableBody}>
                        {araRegelungen
                            .sort((a, b) => a.text.localeCompare(b.text))
                            .map((araRegelung) => (
                                <tr key={araRegelung.art} className={formStyles.looupTableRow}>
                                    <td className={formStyles.lookupTableCell}>{araRegelung.text}</td>
                                    <td className={formStyles.lookupTableActionCell}>
                                        <DefaultButton
                                            className={formStyles.lookupTableEditButton}
                                            onClick={() => setEditData({ ...araRegelung })}
                                            text="Bearbeiten"
                                        />
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>
            {editData && (
                <Dialog
                    hidden={false}
                    minWidth={800}
                    dialogContentProps={{
                        title: 'ARA Regelung bearbeiten',
                        type: DialogType.normal,
                    }}
                >
                    <FormTextField
                        value={editData.text}
                        savingState={SavingState.notChanged}
                        options={{}}
                        onChange={(newValue): void => {
                            if (editData) {
                                setEditData({
                                    ...editData,
                                    text: newValue as string,
                                });
                            }
                        }}
                        label="Name"
                    />
                    <DialogFooter>
                        <DefaultButton onClick={() => setEditData(null)} text="Abbruch" />
                        <PrimaryButton onClick={save} text="Speichern" />
                    </DialogFooter>
                </Dialog>
            )}
        </Fabric>
    );
};
